// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const toggle = "RewardDetailsTabsMobile__toggle__nLuD2 font-faces__sansBold__vF+EN font-faces__sans__uCf65";
export const arrow = "RewardDetailsTabsMobile__arrow__NyrAj";
export const option = "RewardDetailsTabsMobile__option__RLAeM font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const active = "RewardDetailsTabsMobile__active__KkzPq";
export const popupTitleWrapper = "RewardDetailsTabsMobile__popupTitleWrapper__ecmh+";